import Text from "common/Typography/Text.tsx";
import Flex from "common/Boxes/Flex.tsx";
import styled from "styled-components";
import { useContext, useMemo } from "react";
import { WeekDays } from "common/Calendars/types.ts";
import {
  getInactiveDays,
  isInactiveAllDayEvent,
  mergeDayEventsIntoFullDay,
} from "common/Calendars/utils.ts";
import {
  WEEK_DAY_TO_DISPLAY_NAME,
  WEEK_DAYS,
} from "common/Calendars/constants.ts";
import { OperationHoursContext } from "features/bots/BotForm/OperationHours/OperationHours.context.ts";

const DisableDays = () => {
  const { myEvents, setMyEvents } = useContext(OperationHoursContext)!;
  const inactiveDays = useMemo(
    () => getInactiveDays(myEvents || []),
    [myEvents]
  );

  const toggleDay = (dayIndex: WeekDays) => {
    setMyEvents((prev) => {
      const hasAllDayEvent = prev?.some((e) => {
        return isInactiveAllDayEvent(e, dayIndex);
      });
      if (hasAllDayEvent) {
        return prev?.filter((e) => !isInactiveAllDayEvent(e, dayIndex));
      } else {
        return mergeDayEventsIntoFullDay(prev || [], dayIndex);
      }
    });
  };

  return (
    <>
      <Text style={{ marginBottom: 12 }}>Disable Days</Text>
      <Wrapper>
        {WEEK_DAYS.map((day) => (
          <DayWrapper
            key={day}
            $selected={inactiveDays.has(day)}
            onClick={() => toggleDay(day)}
          >
            {WEEK_DAY_TO_DISPLAY_NAME[day].slice(0, 3)}
          </DayWrapper>
        ))}
      </Wrapper>
    </>
  );
};

export default DisableDays;

const Wrapper = styled(Flex)`
  column-gap: 8px;
  row-gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-start;
`;
const DayWrapper = styled.div<{ $selected?: boolean }>`
  background: ${(p) =>
    p.$selected
      ? p.theme.colors.filterChipsActiveColor
      : p.theme.colors.filterChipsColor};
  color: ${(p) =>
    p.$selected ? p.theme.colors.white : p.theme.colors.primaryGrey};
  padding: 0 18px;
  border-radius: 20px;
  height: 32px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;
